import { BaseService } from "./baseService";
import { Note, Attachment } from "../types";
import { createParentFilter } from "../utils/apiHelpers";

class NoteService extends BaseService<Note> {
  constructor() {
    super("Note");
    this.setCacheStrategy("network-first");
    this.setCacheExpiry(2 * 60 * 1000);
  }
  async getNotes(taskId: string): Promise<Note[]> {
    try {
      const selectFields = [
        "id",
        "post",
        "createdAt",
        "createdById",
        "createdByName",
        "attachmentsIds",
        "attachmentsNames",
        "attachmentsTypes",
      ];

      const result = await this.getList({
        where: createParentFilter(taskId, "Task"),
        offset: 0,
        maxSize: 50,
        orderBy: "createdAt",
        order: "desc",
        select: selectFields,
      });

      return result.list;
    } catch (err) {
      console.error("Ошибка при получении заметок:", err);
      return [];
    }
  }

  async createNote(noteData: {
    parentId: string;
    parentType: string;
    post: string;
    type: string;
    isInternal: boolean;
    attachmentsIds?: string[];
    attachmentsNames?: Record<string, string>;
    attachmentsTypes?: Record<string, string>;
  }): Promise<Note> {
    const storedAttachments: { id: string; name: string; type?: string }[] =
      JSON.parse(localStorage.getItem("pendingNoteAttachments") || "[]");

    const payload = {
      ...noteData,
      attachmentsIds:
        noteData.attachmentsIds || storedAttachments.map((a) => a.id),
      attachmentsNames:
        noteData.attachmentsNames ||
        storedAttachments.reduce(
          (acc, a) => ({ ...acc, [a.id]: a.name }),
          {} as Record<string, string>
        ),
      attachmentsTypes:
        noteData.attachmentsTypes ||
        storedAttachments.reduce(
          (acc, a) => ({ ...acc, [a.id]: a.type || "" }),
          {} as Record<string, string>
        ),
    };

    try {
      const result = await this.create(payload);
      localStorage.removeItem("pendingNoteAttachments");
      return result;
    } catch (err) {
      console.error("Ошибка при создании заметки:", err);
      throw err;
    }
  }

  async updateNote(noteId: string, post: string): Promise<Note> {
    return this.update(noteId, { post } as Partial<Note>);
  }

  async deleteNote(noteId: string): Promise<void> {
    return this.delete(noteId);
  }
}

export const noteService = new NoteService();

export type { Note };
export const getNotes = (taskId: string) => noteService.getNotes(taskId);
export const createNote = (
  noteData: Parameters<typeof noteService.createNote>[0]
) => noteService.createNote(noteData);
export const updateNote = (noteId: string, post: string) =>
  noteService.updateNote(noteId, post);
export const deleteNote = (noteId: string) => noteService.deleteNote(noteId);
